import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import React, { useEffect } from "react";
import { LoadingButton } from "@mui/lab";
import { useSelector } from "react-redux";
import PartitionList from "pages/vending/partition/list/PartitionList";
import PartitionRefill from "pages/refill/PartitionRefill";

const TrayItem = ({ tray, handleClick, handleDelete, refill_mod,openRows }) => {
  useEffect(() => {
      setExpanded(openRows);
    },[openRows])
  const [expanded, setExpanded] = React.useState(openRows);
  const deleteTrayLoading = useSelector(
    (state) => state.vending.trays.deleteTrayLoading
  );
  return (
    <Accordion expanded={expanded}>
      <AccordionSummary
        expandIcon={
          <IconButton onClick={() => setExpanded((state) => !state)}>
            <ExpandMoreIcon />
          </IconButton>
        }
        sx={{ display: "flex" }}
      >
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          sx={{ flexGrow: 1 }}
        >
          <Stack direction="row" alignContent="center">
            <Typography>Tray {tray.number} </Typography>
            <Typography variant="caption" marginLeft={1}>
              ({tray.partition_count} partitions)
            </Typography>
          </Stack>
          {!refill_mod && (
            <Box>
              <Button
                variant="outlined"
                size="small"
                color="info"
                onClick={(e) => handleClick(tray)}
              >
                Edit
              </Button>
              <LoadingButton
                variant="outlined"
                size="small"
                color="error"
                loading={deleteTrayLoading}
                sx={{ marginLeft: 1, marginRight: 3 }}
                onClick={() => handleDelete(tray.id)}
              >
                Delete
              </LoadingButton>
            </Box>
          )}
        </Stack>
      </AccordionSummary>
      <AccordionDetails>
        {refill_mod ? (
          <PartitionRefill tray={tray} />
        ) : (
          <PartitionList tray={tray} />
        )}
      </AccordionDetails>
    </Accordion>
  );
};

export default TrayItem;
